import type { AdvertisingModalContent } from '@/AdvertisingModal/types'
import { EMAIL_REGEX } from '@/validation'

export const COURSE_THUMB =
  'https://vinc.gumlet.io/gallery/video-thumbnails/10x10.jpg?nocache=256559665'

export const freemagicFormFields: NonNullable<AdvertisingModalContent['formFields']> =
  [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      placeholder: 'First and last name',
      required: true,
      validation: {
        pattern: /^[a-zA-Z]+\s+[a-zA-Z]+/,
        message: 'Please enter your first and last name',
      },
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'your@email.com',
      required: true,
      validation: {
        pattern: EMAIL_REGEX,
        message: 'Please enter a valid email address',
      },
    },
  ]

/** Default embedded card styling (spread into signup components). */
export const freemagicEmbeddedChrome = {
  customInputClassName:
    'mb-3 block w-full rounded-md border border-[#ced4da] px-4 py-2.5 text-lg text-[#212529] placeholder:text-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
  customButtonClassName: 'w-full py-3 text-lg',
  customTitleClassName: 'mb-4 mt-2 text-2xl font-medium leading-tight text-[#212529]',
  customIntroClassName:
    'mb-4 space-y-4 text-left text-base leading-normal text-[#212529] [&_p]:mb-4 [&_p:last-child]:mb-0',
  customSuccessClassName: 'py-6 text-center',
  customSuccessTitleClassName: 'mb-2 text-base font-semibold text-green-700',
  customSuccessMessageClassName: 'text-sm text-green-700',
  hideTitleInSuccess: true,
  hideLabels: false,
  hideErrorBox: false,
  embeddedClassName: '!mb-0 !rounded-none !border-0 !bg-transparent !p-0 !shadow-none',
} as const

export function withFreemagicFormFields(
  content: Omit<AdvertisingModalContent, 'formFields'>
): AdvertisingModalContent {
  const { imageUrl: _imageUrl, imageAlt: _imageAlt, ...rest } = content
  return { ...rest, formFields: freemagicFormFields }
}
